import React, {createContext, useEffect, useState} from 'react'
import {SettingsConsumer, SettingsProvider} from './@core/context/settingsContext'
import ThemeComponent from './@core/theme/ThemeComponent'
import ReactHotToast from './@core/styles/libs/react-hot-toast'
import {Toaster} from 'react-hot-toast'
import UserLayout from './layouts/UserLayout'

// TODO: el layout del sistema tiene que venir con el layout ya
import {Messages} from './pages'

// import Home from './pages/home'
import Graphs from 'src/pages/grafo/Visualizador'

import Notifications from 'src/pages/notifications'

// import HomeWorkflows from './pages/segmentos/home'
import {LoaderProvider} from './context/LoaderContext'
import {createBrowserRouter, Navigate, Outlet, RouterProvider, useLocation} from 'react-router-dom'
import {sistemaRouter} from './pages/sistema/RefactorLayout'
import {ConfirmActionProvider} from './context/ConfirmActionContext'
import {adminRouter} from './pages/admin'
import {GoogleOAuthProvider} from '@react-oauth/google'
import {userStorage} from './utils/localStorage'
import Error404 from './pages/404'
import {RUTAS} from './Rutas'
import BlankLayout from './@core/layouts/BlankLayout'
import {Login} from './pages/login'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import SecurityManager from './pages/managers/SecurityManager'
import {useAction} from './hooks/useAction'
import {AppSecObjects, DictionarySecurityObject, SecurityComponents} from './types/security'
import {SafetyRoute} from './components/security'
import Dashboard from "./pages/dashboard/Dashboard";
import {AuthProvider} from "./context/AuthContext";
import Error500 from "./pages/500";
import Limites from "./pages/limites/Limites";

// import Security from "./pages/security"

// import { SistemaLayout, Sistema } from './pages/sistema'

// TODO: hay que mejorar el router (sobre todo lo de los layouts)
// quedó un poco mamarracho...
const router = createBrowserRouter([
    // { path: "*", element: <Root /> },
    { path: RUTAS.LOGIN, element: <RedirectIfAuthenticated /> },
    { path: '/', element: <Navigate to={`/${RUTAS.LOGIN}`} /> },
    {
        path: '',
        element: <AuthProvider><ProtectedRoute /></AuthProvider>,
        errorElement: <AuthProvider><Error500 /></AuthProvider>,
        children: [
            ...sistemaRouter,
            {
                path: '',
                element: <UserLayout />,
                children: [
                    { path: RUTAS.HOME, element: <Messages /> },
                    {
                        path: RUTAS.GRAFO,
                        element: (
                            <SafetyRoute
                                componentName={SecurityComponents.AppRutas}
                                objectName={AppSecObjects.RutaWorkflowGrafo}
                            >
                                <Graphs />
                            </SafetyRoute>
                        )
                    },
                    { path: RUTAS.NOTIFICACIONES, element: <Notifications /> },
                    { path: RUTAS.REPORTES, element: <div /> },
                    { path: RUTAS.DASHBOARD, element: <Dashboard /> },
                    { path: RUTAS.LIMITES, element: <Limites /> },
                    ...adminRouter
                ]
            }
        ]
    },
    { path: '', element: <Error404 /> }
])

function RedirectIfAuthenticated() {
    if (!!userStorage.hasToken()) {
        return <Navigate to={`/${RUTAS.HOME}`} />
    }

    return (
        <BlankLayout>
            <Login />
        </BlankLayout>
    )
}

function ProtectedAdminRoute() {
    // TODO: hook y contexto usuario!
    if (!userStorage.isAdmin()) {
        return <Error404 />
    }

    return <Outlet />
}

export const SecurityObjectContext = createContext({
    dictionarySecurityObject: {} as DictionarySecurityObject | undefined
})

function App() {
    const { reloadProfile } = useAction()
    const [dictionarySecurityObject, setDictionarySecurityObject] = useState<DictionarySecurityObject | undefined>()

    useEffect(() => {
        reloadProfile()
    }, [userStorage.getUserId])

    return (
        <Provider>
            <GoogleOAuthProvider clientId={window.GOOGLE_CLIENT_ID}>
                <SecurityObjectContext.Provider value={{ dictionarySecurityObject }}>
                    <SecurityManager setDictionarySecurityObject={setDictionarySecurityObject} />

                    <RouterProvider router={router} />
                </SecurityObjectContext.Provider>
            </GoogleOAuthProvider>
        </Provider>
    )
}

function Provider({ children }: { children: React.ReactNode }) {
    return (
        <QueryClientProvider client={new QueryClient()}>
            <SettingsProvider>
                <SettingsConsumer>
                    {({ settings }) => {
                        return (
                            <ThemeComponent settings={settings}>
                                <LoaderProvider>
                                    <ConfirmActionProvider>{children}</ConfirmActionProvider>
                                </LoaderProvider>

                                <ReactHotToast>
                                    <Toaster
                                        position={settings.toastPosition}
                                        toastOptions={{ className: 'react-hot-toast' }}
                                    />
                                </ReactHotToast>
                            </ThemeComponent>
                        )
                    }}
                </SettingsConsumer>
            </SettingsProvider>
        </QueryClientProvider>
    )
}

function ProtectedRoute() {
    const location = useLocation()

    if (!userStorage.hasToken()) {
        return <Navigate to={`${RUTAS.LOGIN}`} state={{ from: location }} />
    }

    return <Outlet />
}

export default App
